import type { CSSProperties, ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function Marquee<T>({
  label,
  items,
  renderItem,
  itemKey,
  duration = 48,
  gap = 12,
  reverse = false,
  className,
}: {
  label: string
  items: T[]
  renderItem: (item: T) => ReactNode
  itemKey: (item: T) => string
  duration?: number
  gap?: number
  reverse?: boolean
  className?: string
}) {
  const style = {
    '--marquee-duration': `${duration}s`,
    '--marquee-gap': `${gap}px`,
  } as CSSProperties

  return (
    <div
      className={cn('marquee mask-fade-x', reverse && 'marquee-reverse', className)}
      style={style}
    >
      <ul aria-label={label} className="marquee-track">
        {items.map((item) => (
          <li key={itemKey(item)} className="shrink-0">
            {renderItem(item)}
          </li>
        ))}
      </ul>
      <ul aria-hidden="true" className="marquee-track">
        {items.map((item) => (
          <li key={itemKey(item)} className="shrink-0">
            {renderItem(item)}
          </li>
        ))}
      </ul>
    </div>
  )
}
